function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.2822 131.754C47.0906 125.509 44.806 118.321 45.7082 111.86C45.0962 111.243 44.5135 110.602 43.9601 109.937C39.1429 104.142 36.9938 96.659 37.9397 89.1356L18.3776 65.6052L19.7872 61.5863C25.4695 45.3248 49.4331 24.5914 64.768 22.6683L68.8006 22.1629L85.4567 41.6204C102.609 35.77 118.819 43.2826 127.973 54.2941C128.275 54.6562 128.576 55.0184 128.849 55.387C136.362 65.0814 137.621 76.8301 132.581 87.1943L157.153 116.79C168.511 130.472 160.974 140.859 157.205 144.688C153.496 148.45 149.397 150.368 144.983 150.396C138.155 150.445 132.66 145.926 127.748 141.053C124.377 137.715 116.788 130.319 110.393 124.081C109.415 124.894 108.377 125.657 107.283 126.352C103.399 137.51 92.1071 146.765 75.9442 144.626C66.6837 143.402 58.0678 138.713 52.2985 131.774L52.2822 131.754Z",
  fill: "#FDFDFC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M100.647 113.511L119.245 98.828L113.645 66.9843L94.8223 54.8565L73.8479 51.6687L58.2967 58.7872L51.7977 84.8979L51.7645 98.019L68.9859 127.435L100.647 113.511Z",
  fill: "#FDFDFC",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M85.1373 52.844L65.7063 30.1482C53.6541 31.6596 31.8185 49.9948 26.8884 64.075L48.1105 89.6021",
  fill: "#FDFDFC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M85.1373 52.844L65.7063 30.1482C53.6541 31.6596 31.8185 49.9948 26.8884 64.075L48.1105 89.6021",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M60.0839 112.208C47.9802 107.604 43.862 97.653 45.6408 88.6426C46.9525 81.9573 52.6958 74.8485 55.6025 72.73",
  fill: "#FDFDFC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M60.0839 112.208C47.9802 107.604 43.862 97.653 45.6408 88.6426C46.9525 81.9573 52.6958 74.8485 55.6025 72.73",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M101.101 119.772C100.162 128.2 92.3445 139.185 76.923 137.141C59.2071 134.787 48.7377 117.933 54.7805 108.456C60.8233 98.9796 76.4414 107.134 80.9519 116.063",
  fill: "#FDFDFC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M101.101 119.772C100.162 128.2 92.3445 139.185 76.923 137.141C59.2071 134.787 48.7377 117.933 54.7805 108.456C60.8233 98.9796 76.4414 107.134 80.9519 116.063",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M121.499 85.6313L151.342 121.587C155.15 126.168 158.379 132.72 151.818 139.383C145.257 146.046 139.535 142.13 133.033 135.683C126.532 129.236 104.57 107.916 104.57 107.916",
  fill: "#FDFDFC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M121.499 85.6313L151.342 121.587C155.15 126.168 158.379 132.72 151.818 139.383C145.257 146.046 139.535 142.13 133.033 135.683C126.532 129.236 104.57 107.916 104.57 107.916",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M112.214 106.858C111.032 114.197 103.711 124.803 87.089 123.227C69.5451 121.557 56.9677 103.94 65.9283 93.9906C73.4496 85.6356 87.5892 92.6682 92.0997 101.598",
  fill: "#FDFDFC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M112.214 106.858C111.032 114.197 103.711 124.803 87.089 123.227C69.5451 121.557 56.9677 103.94 65.9283 93.9906C73.4496 85.6356 87.5892 92.6682 92.0997 101.598",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M104.497 72.8847C95.5497 73.9499 87.8147 81.0922 90.3652 89.5161C92.8718 97.8275 106.843 104.04 119.939 91.7785C127.991 84.2406 132.046 71.8152 122.892 60.0084C114.134 48.717 96.6195 41.2291 79.0368 53.2312",
  fill: "#FDFDFC"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M104.497 72.8847C95.5497 73.9499 87.8147 81.0922 90.3652 89.5161C92.8718 97.8275 106.843 104.04 119.939 91.7785C127.991 84.2406 132.046 71.8152 122.892 60.0084C114.134 48.717 96.6195 41.2291 79.0368 53.2312",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgKiwiHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 192,
    viewBox: "0 0 185 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiwiHand);
export default __webpack_public_path__ + "static/media/kiwi-hand.958239d8.svg";
export { ForwardRef as ReactComponent };